export const useAppleSdk = () => {
    const loading = ref(true);
    const error = ref(null);

    let appleInstance = null;
    let initPromise = null;

    const loadSdk = () => {
        return new Promise((resolve, reject) => {
            if (document.getElementById('appleid-sdk')) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.id = 'appleid-sdk';
            script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
            script.async = true;
            script.onload = resolve;
            script.onerror = () => reject(new Error('Failed to load Apple SDK'));
            document.head.appendChild(script);
        });
    };

    const getSdk = async () => {
        if (typeof window === 'undefined') {
            error.value = 'Not running in browser';
            loading.value = false;
            return null;
        }

        if (appleInstance) {
            return appleInstance;
        }

        if (!initPromise) {
            initPromise = new Promise(async (resolve, reject) => {
                try {
                    await loadSdk();
                    if (window.AppleID) {
                        appleInstance = window.AppleID;
                        resolve(appleInstance);
                    } else {
                        throw new Error('AppleID object not available after loading script');
                    }
                } catch (err) {
                    error.value = err.message;
                    reject(err);
                } finally {
                    loading.value = false;
                }
            });
        }

        return initPromise;
    };

    return { getSdk, loading, error };
};